import { useNavigate } from "react-router-dom";
const sizePalette = { md: "c-btn", lg: "bottombtn", xl: "mode-select-btn" };
const colorPalette = {
  primary: "bottombtn-b",
  secondary: "bottombtn-w",
  secondaryGray: "practice-btn",
};

const Button = ({
  size = "md",
  color = "primary",
  children,
  type = "button",
  onClick,
  redirectionURL,
}) => {
  const navigate = useNavigate();
  return (
    <button
      onClick={() => {
        if (onClick) onClick();
        if (redirectionURL) {
          navigate(redirectionURL);
        }
      }}
      type={type}
      className={`${sizePalette[size]} ${colorPalette[color]}`}
    >
      {children}
    </button>
  );
};

export default Button;
